<template>
  <div class="detail-table-section">
    <div class="table-title">
      <span>{{ $l('tips_title_purchase_fabric_detail') || '产品明细' }}</span>
    </div>

    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      show-footer
      :footer-method="footerMethod"
    >
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>

<script>
import tableColumns from './table-columns'
import TableAutoHeightV2 from '@/mixins/table-auto-height-v2'

export default {
  mixins: [TableAutoHeightV2],
  props: {
    purchaseFabricCode: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      minTableHeight: 260,  // 配置最小高度
      safetyMargin: 10,     // 配置安全边距
      tableColumns: tableColumns(this),
    }
  },
  watch: {
    purchaseFabricCode: {
      handler(val) {
        if (val) {
          this.getData()
        }
      },
      immediate: true
    }
  },
  mounted() {
    // 移除手动监听，使用 mixin 中的 mounted
  },
  methods: {
    getData() {
      if (!this.purchaseFabricCode) return

      this.loading = true
      this.$api
        .purchaseFabricDetailListApi({
          purchaseFabricCode: this.purchaseFabricCode
        })
        .then((res) => {
          this.loading = false
          // 数据在 body.data
          this.tableData = res.body?.data || []
          // 数据加载完成后重新计算表格高度
          this.recalculateTableHeight()
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 合计行计算
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 1) {
            return '合计'
          }

          // 数量合计
          if (column.property === 'qty') {

            const total = data.reduce((sum, row) => {
              const qty = parseFloat(row.qty) || 0
              return sum + qty
            }, 0)
            return total.toFixed(2)
          }

          // 价税合计求和
          if (column.property === 'subAmount') {
            const total = data.reduce((sum, row) => {
              const amount = parseFloat(row.subAmount) || 0
              return sum + amount
            }, 0)
            return total.toFixed(2)
          }

          return null
        }),
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.detail-table-section {
  background: #fff;
  padding-bottom: 5px;
}

.table-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}

::v-deep {
  .vxe-table--footer {
    .vxe-footer--row {
      background-color: #f5f7fa;
      font-weight: 600;

      .vxe-footer--column {
        &:first-child {
          text-align: center;
        }
      }
    }
  }

}
</style>
